import { render, staticRenderFns } from "./matchingPlan.vue?vue&type=template&id=e13912e0&scoped=true&"
import script from "./matchingPlan.vue?vue&type=script&lang=js&"
export * from "./matchingPlan.vue?vue&type=script&lang=js&"
import style0 from "./matchingPlan.vue?vue&type=style&index=0&id=e13912e0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13912e0",
  null
  
)

export default component.exports